import { IDSHeaderInera } from '@platformui/core/ids/header-inera/ids-header-inera'
import {
    IDSHeaderIneraActionItemProps,
    IDSHeaderIneraItemProps,
    IDSHeaderIneraLinkItemProps,
} from '@platformui/core/ids/header-inera/ids-header-inera-item'
import { IDSIcon } from '@platformui/core/ids/icons/font-icons/icon'
import { usePageInfo } from '@platformui/core/infrastructure/features/page-info/page-info-hook'
import { GlobalSearch } from '@platformui/core/components/global-search/global-search'
import clsx from 'clsx'
import { FC } from 'react'
import { ActiveTool, ActiveToolType, useActiveTool } from './active-tool-hook'
import { AlertMessagesList } from '@platformui/core/components/alert-list/alert-list'
import { useIsMediumViewport } from '@platformui/core/hooks/useMedia'

/* const MobileHeaderTools = (props) => {
  return (
    <div className="c-metanav">
      <ul className="c-metanav__list">
        <AuthTool {...props} />
      </ul>
    </div>
  );
};
 */

const globalSearchFactory = (
    label: string,
    toggle: (value: ActiveTool) => void
): IDSHeaderIneraActionItemProps => {
    return {
        type: 'action',
        showOnSmallScreens: true,
        onClick: () => toggle(ActiveToolType.Search),
        text: label,
        icon: <IDSIcon icon="search" colorPreset={2} />,
    }
}

const serviceInfoFactory = (
    label: string,
    link?: string
): IDSHeaderIneraLinkItemProps => {
    return {
        type: 'link',
        showOnSmallScreens: true,
        href: link || '', // TODO: it would save us some headache if backend could promise a link.
        text: label,
        icon: <IDSIcon icon="desktop" colorPreset={2} />,
    }
}

const customerPortalFactory = (
    label: string,
    link: string | undefined
): IDSHeaderIneraLinkItemProps => {
    return {
        type: 'link',
        showOnSmallScreens: true,
        href: link || '',
        text: label,
        icon: <IDSIcon icon="user" colorPreset={2} />,
    }
}

export const IneraHeader: FC = () => {
    const {
        siteHeader,
        mainNavigation,
        secondaryNavigation,
        messages,
        translations,
    } = usePageInfo()
    const { activeTool, toggle } = useActiveTool()
    const { search, serviceInfo, customerPortal } = siteHeader
    const isMediumViewport = useIsMediumViewport()

    const classes = clsx('header', {
        'header--panel-is-open': activeTool !== ActiveToolType.None,
        'header--search-is-open': activeTool === ActiveToolType.Search,
    })

    const items: IDSHeaderIneraItemProps[] = []
    if (customerPortal && customerPortal.enabled && !isMediumViewport) {
        items.push(
            customerPortalFactory(customerPortal.label, customerPortal.link)
        )
    }

    if (serviceInfo && serviceInfo.enabled && !isMediumViewport) {
        items.push(serviceInfoFactory(serviceInfo.label, serviceInfo.link))
    }

    if (search && search.enabled) {
        items.push(globalSearchFactory(search.label, toggle))
    }

    return (
        <>
            {activeTool === ActiveToolType.Search && (
                <GlobalSearch
                    hasQuickSearch={false}
                    isMobile={false}
                    id="search"
                    siteHeader={siteHeader.search}
                    modifiers={{ 'header-panel': true }}
                    isVisible={activeTool === ActiveToolType.Search}
                    hasAutoComplete={true}
                />
            )}
            <div className={classes}>
                <IDSHeaderInera
                    items={items}
                    menuItems={mainNavigation}
                    secondaryMenuItems={secondaryNavigation}
                />
                <AlertMessagesList
                    messages={messages ?? []}
                    content={{ translations: translations ?? {} }}
                />
                {/* <PlatformHeader // TODO: removet this when all parts of the header is integrated with the IDS header
          noTopNavRow={true}
          // alertListFullWidth
          chevronMobile="chevron--mobile"
          Tools={Tool}
          ToolsBottom={HeaderTools}
          isWideNav={true}
          activeTool={activeTool}
          toggle={toggle}
          translations={pageInfo.translations}
          mainNavigation={mainNavigation}
        /> */}
            </div>
        </>
    )
}
